import { LuPlay, LuInfo, LuArrowRight, LuGithub, LuShield } from "react-icons/lu"
import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import "./Hero.css"

function Hero() {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    setLoaded(false)

    const timer = setTimeout(() => {
      setLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [location.pathname])

  return (
    <section className={`hero ${loaded ? "loaded" : ""}`}>
      <div className="hero-left">
        <h1>
          We Provide <span>Career Roadmaps</span><br />
          For Focused Students
        </h1>

        <div className="dotted-panel">
          <p>
            Clear direction. Structured learning paths. Real-world skill building.
            We guide students step-by-step so they don’t waste years figuring things out.
          </p>
        </div>

        <div className="hero-buttons">
          <button
            className="primary-btn"
            onClick={() => navigate("/signup")}
          >
            <LuArrowRight className="btn-icon" /> Get Started
          </button>

          <button className="primary-btn blue-btn" onClick={() => navigate("/login")}>
            <LuPlay className="btn-icon" /> Login
          </button>

          <button
            className="secondary-btn gold-btn"
            onClick={() =>
              document
                .getElementById("our-connections")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            <LuInfo className="btn-icon" /> Learn More
          </button>

          <button
            className="secondary-btn silver-btn"
            onClick={() =>
              window.open(
                "https://github.com/sanketpadhyal/Sluz",
                "_blank"
              )
            }
          >
            <LuGithub className="btn-icon" /> SLZ Repository
          </button>

          <button
            className="secondary-btn trust-btn"
            onClick={() =>
              document
                .getElementById("why-trust-us")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            <LuShield className="btn-icon" /> Why Trust Us
          </button>
        </div>
      </div>

      <div className="hero-right">
        <div className="image-wrapper">

          {!imageLoaded && <div className="hero-skeleton"></div>}

          <img
            src="/assets/home.png"
            alt="career roadmap illustration"
            className={`hero-image ${imageLoaded ? "image-show" : "image-hide"}`}
            onLoad={() => setImageLoaded(true)}
            draggable="false"
          />

        </div>
      </div>
    </section>
  )
}

export default Hero